import ApiCallManager from '../models/apiCallManager';

/**
 * @ngdoc service
 * @name CustomerService
 * @description
 * This service is meant to fetch the Customer information.
 *
 * @memberof common
 */
class CustomerService extends ApiCallManager {
  /**
   * Class constructor.
   * @param {Service} appUtils               The service to get the page query param.
   * @param {Service} contentCreatorAdminAPI The service to fetch the Customer information.
   * @ignore
   */
  constructor(
    appUtils,
    contentCreatorAdminAPI,
  ) {
    'ngInject';

    super(
      appUtils,
      ((content) => content),
      contentCreatorAdminAPI.getCustomer.bind(contentCreatorAdminAPI),
    );
  }
  /**
   * Get the the Customer information.
   * @param {Boolean} refresh flag to force a refresh of the Customer.
   * @return {Promise}
   */
  getCustomer(refresh = false) {
    return this._getContent(refresh);
  }
}

export default CustomerService;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/services/customer.js